import { Component, OnInit } from '@angular/core';
import { RouterService } from '@app/core/router/router.service';
import { Store } from '@ngrx/store';
import { AppState } from '@app/core/core.state';
import { UpdateInterfaz } from '@app/core/interfaz/interfaz.actions';
import { BreakpointObserver } from '@angular/cdk/layout';
@Component({
  selector: 'mooc-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  toogle: boolean = false;
  loginState: boolean = false;
  menuState: boolean = false;
  closeButtonState: boolean = false;

  constructor(
    private routerService: RouterService,
    private store: Store<AppState>,
    private breakPoint : BreakpointObserver
  ) { }

  resMenu = false

  ngOnInit() {
    this.breakPoint.observe([
    '(max-width : 1200px)'
    ]).subscribe(result => {
      if(this.breakPoint.isMatched('(max-width : 1200px)')){
        this.resMenu = true
      }else{
        this.resMenu = false
      }
    })
  }

  goRoute(path: string) {
    this.routerService.goRoute(path);
  }

  openSidenav($event: boolean) {
    const toogle = $event;
    this.store.dispatch(new UpdateInterfaz("sidenavMenu", {
      state: toogle
    }));
  }

  toggleMenu() {
    this.menuState = !this.menuState;
    this.closeButtonState = !this.closeButtonState;
  }

  closeModalRes(){
    if(this.resMenu){
      this.menuState = false
      this.closeButtonState = false
    }
  }

  toggleLogin() {
    this.loginState = true;
  }

  logOutUser() {
    localStorage.clear();
    location.reload();
  }

  clickLogin(loginC: boolean) {
    this.loginState = loginC;
  }
}
